// extracted by mini-css-extract-plugin
export var contentContainer = "LogosModule-module--contentContainer--06351";
export var logoContainer = "LogosModule-module--logoContainer--838a4";
export var logoLink = "LogosModule-module--logoLink--3b0b7";
export var logosContainer = "LogosModule-module--logosContainer--ba54e";
export var scrollingWrapper = "LogosModule-module--scrollingWrapper--c2077";
export var title = "LogosModule-module--title--a1f41";
export var titleContainer = "LogosModule-module--titleContainer--82ed8";